import isServer from '@/Framework/Router/Next/isServer';
import globalKey from './globalKey';

export default (key: string): string => (
  isServer() ? process.env[key] : window[globalKey]?.[key]
);
